<template>
  <!-- <div class="hom-wrapper-box"> -->
    <div class="home-wrapper">
      <!-- 背景动画 -->
      <span class="cloud">
        <img src="../assets/img/cloud.png" />
      </span>
      <span class="bird">
        <img src="../assets/img/bird.png" />
      </span>
      <span class="cloud1">
        <img src="../assets/img/cloud.png" />
      </span>
      <img src="../assets/img/img2.png" class="icon-top-img" />
      <img src="../assets/img/bg.png" class="time-line-box-bg" />
      <img src="../assets/img/img1.png" class="icon-top-img1" />
      <span class="text-bottom">封面新闻出品</span>
      <!-- 中间部分 -->
      <div class="time-line-box" ref="timeLineBox">
        <!-- <div class="top">
          <div class="content"></div>
          <img src="../assets/img/img1.png" class="top-img" />
          <img src="../assets/img/topBg.png" class="top-bg" />
        </div> -->
        <div class="center-box" ref="scrollDiv" @scroll="scrollEvent">
          <div class="center">
            <div
              class="center-item"
              v-for="(val, key, index) in yearArr"
              :key="key"
            >
              <div class="year yearStart">
                <p class="content">{{ capitalizeStart(key) }}</p>
              </div>
              <div
                :class="`year-content status${status}`"
                v-for="history in val"
                :key="history.title"
              >
                <p :class="`vertical-line status${status}`"></p>
                <img src="../assets/img/center.png" class="icon" />
                <p class="line"></p>
                <div
                  :class="[
                    history.title == '中华人民共和国成立'
                      ? statusChange
                        ? 'name-box name-box-new active'
                        : 'name-box name-box-new'
                      : statusChange
                      ? 'name-box active'
                      : 'name-box',
                  ]"
                  @click="openHistory(history.title, history.biref, history.id)"
                >
                  <span class="empty"></span>
                  <div class="text">
                    <span>{{ history.sub_title }}</span>
                  </div>
                </div>
              </div>
              <div class="year" v-if="index == yearListLength - 1">
                <p class="content">{{ capitalizeEnd(key) }}</p>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="bottom">
          <img src="../assets/img/img3.png" class="bottom-img" />
        </div> -->
      </div>
      <!-- 右侧固定伸缩栏 -->
      <div class="right-box">
        <!-- <div
          v-for="(item, index) in uprights"
          :class="[
            uprightsNow == index
              ? 'upright-item open'
              : uprightsClose == index
              ? 'upright-item close'
              : 'upright-item',
          ]"
          :key="item.title"
        > -->
        <div
          v-for="(item, index) in uprights"
          class="upright-item"
          :key="item.title"
          @click="clickRight(index)"
        >
          <!-- <img
            src="../assets/img/open.png"
            :class="[uprightsNow == index ? 'open toClose' : 'open']"
          /> -->
          <!-- <img :src="item.img" class="bg" @click="rightLeftTurn(index)" /> -->
          <img :src="lightNum == index ? item.activeImg : item.img" class="bg" />
          <!-- <div class="upright-item-stretch">
            <div class="title-box" @click="goWike(item.title)">
              <span class="left">{{ item.title }}</span>
              <span class="right">查看详情 ></span>
            </div>
            <p class="time">{{ item.time }}</p>
            <p class="content">{{ item.content }}</p>
          </div> -->
        </div>
      </div>
      <!-- 弹窗，党史百科 -->
      <div
        class="history-flag"
        v-if="historyVisible"
        @click.self="closeHistory()"
      >
        <div class="flag-content">
          <img
            src="../assets/img/close.png"
            class="history-close"
            @click.prevent="closeHistory()"
          />
          <div class="flag-center">
            <p class="history-head">
              <img src="../assets/img/img2.png" class="flag-head-img1" />
              <span class="flag-head-line"></span>
              <img src="../assets/img/history.png" class="flag-head-img2" />
            </p>
            <p class="history-title">{{ historyTitle }}</p>
            <p class="history-content" v-html="historyContent"></p>
            <div class="history-more-wrap"></div>
          </div>
          <div class="flag-btns" @click.prevent="goWike()">查看详情</div>
          <!-- <div class="flag-btns">
            <img
              src="../assets/img/history-detail.png"
              class="history-detail"
              @click.prevent="goWike()"
            />
          </div> -->
        </div>
      </div>
      <!-- 海报 -->
      <div class="poster-box" v-if="showPosterBox" @click="clickRight(4)">
        <div class="poster-info">
          <img
            class="poster-img"
            :src="posterImg"
            alt=""
            @click.stop="posterImgClick"
          />
          <p class="save-tips-text">
            {{ isApp ? "点击图片分享海报" : "长按图片保存到手机" }}
          </p>
        </div>
      </div>
      <!-- 页面一打开指导 -->
      <div class="open-flag" v-if="openVisible">
        <div class="open-box">
          <img src="../assets/img/open1.png" class="open1" />
          <img
            src="../assets/img/open2.png"
            class="open2"
            @click.self="closeOpen()"
          />
        </div>
      </div>
      <!-- 放到缩小 -->
      <div class="operate-box">
        <img src="../assets/img/smallNo.png" v-if="status == 1" />
        <img
          src="../assets/img/small.png"
          v-if="status > 1"
          @click="turnScale('small')"
        />
        <img src="../assets/img/bigNo.png" v-if="status == 4" />
        <img
          src="../assets/img/big.png"
          v-if="status < 4"
          @click="turnScale('big')"
        />
      </div>
      <!-- 开机图 -->
      <div class="access-images-box" v-if="access" @click="accessPage()">
        <div class="access-images-content">
            <img src="../assets/img/logo.png" class="one">
            <img src="../assets/img/bg4.png" class="two">
            <img src="../assets/img/bg5.png" class="three">
            <img src="../assets/img/bg6.png" class="four">
            <img src="../assets/img/bg7.png" class="five">
        </div>
      </div>
    </div>
  <!-- </div> -->
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import { mapState } from "vuex";
import COVERAPP from "@/utils/COVERAPP";
@Options({
  data() {
    return {
      // 右侧抽屉
      uprights: [
        {
          img: require("@/assets/img/right1.png"),
          activeImg: require("@/assets/img/active1.png"),
          smallYear: "2012",
          // title: "春天的故事",
          // time: "1978-2021",
          // content:
          //   "1920年8月，上海共产党早期组织正式成立。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。",
        },
        {
          img: require("@/assets/img/right2.png"),
          activeImg: require("@/assets/img/active2.png"),
          smallYear: "1978",
          // title: "春天的故事",
          // time: "1978-2021",
          // content:
          //   "1920年8月，上海共产党早期组织正式成立。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。",
        },
        {
          img: require("@/assets/img/right3.png"),
          activeImg: require("@/assets/img/active3.png"),
          smallYear: "1949",
          // title: "春天的故事",
          // time: "1978-2021",
          // content:
          //   "1920年8月，上海共产党早期组织正式成立。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。",
        },
        {
          img: require("@/assets/img/right4.png"),
          activeImg: require("@/assets/img/active4.png"),
          smallYear: "1921",
          // title: "春天的故事",
          // time: "1978-2021",
          // content:
          //   "1920年8月，上海共产党早期组织正式成立。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。",
        },
        {
          img: require("@/assets/img/share.png"),
          activeImg: require("@/assets/img/share.png"),
          // title: "春天的故事",
          // time: "1978-2021",
          // content:
          //   "1920年8月，上海共产党早期组织正式成立。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。参加者有陈独秀、李汉俊、李达、陈望道、俞秀松等，陈独秀任书记。",
        },
      ],
      uprightsOpen: -1,
      uprightsClose: -1,
      lightNum: -1,
      lightArr: [
        {
          start: new Date().getFullYear(),
          end: 2012,
        },
        {
          start: 2012,
          end: 1978,
        },
        {
          start: 1978,
          end: 1949,
        },
        {
          start: 1949,
          end: 1921,
        },
      ],
      // 事件list 第一维度
      yearArr: 0,
      // 事件缩放颗粒
      status: 1, // 1,2,3,4
      //弹框数据
      historyTitle: "",
      historyContent: "",
      historyId: "",
      historyVisible: false,
      showPosterBox: false,
      posterImg: "",
      statusChange: false, //控制动画
      isApp: false,
      openVisible: true,
      //收缩手势
      isGestureStart: false,
      startDst: 0,
      scale: 1,
      access:true//开机图
    };
  },
  computed: {
    ...mapState(["userInfo", "shareData", "activityData"]),
  },
  watch: {
    status: {
      //深度监听，可监听到对象、数组的变化
      handler(val, oldVal) {
        // console.log("新颗粒度，老颗粒度", val, oldVal);
        let self = this;
        if (val == 1) {
          self.yearArr = self.yearList1;
          self.getLength(self.yearList1);
        } else if (val == 2) {
          self.yearArr = self.yearList2;
          self.getLength(self.yearList2);
        } else if (val == 3) {
          self.yearArr = self.yearList3;
          self.getLength(self.yearList3);
        } else {
          self.yearArr = self.yearList4;
          self.getLength(self.yearList4);
        }
        if (oldVal) {
          self.statusChange = true;
          setTimeout(function () {
            self.statusChange = false;
          }, 3000);
        }
        self.$nextTick(function () {
          self.scrollEvent();
        });
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    let self = this;
    let homeShareData = JSON.parse(JSON.stringify(this.shareData));
    homeShareData.link = window.location.href;
    this.isApp = COVERAPP.Attribute.isApp();
    this.$common.onshare(homeShareData);
    this.getDetail();
    let square = document.getElementsByClassName("home-wrapper")[0];
    square.addEventListener("touchstart", function (event: any) {
      if (event.touches.length >= 2) {
        //标记已经触发了手势开始
        self.isGestureStart = true;
        //计算一下两个触点的初始距离
        self.startDst = self.getDst(event.touches[0], event.touches[1]);
      }
    });
    square.addEventListener("touchmove", function (event: any) {
      if (event.touches.length >= 2) {
        // 计算当前两个触点的距离
        let currentDst = self.getDst(event.touches[0], event.touches[1]);
        // 计算当前两个触点的距离 和 两个触点的初始距离 比例
        self.scale = currentDst / self.startDst;
      }
    });
    // 手势结束
    // 触发过手势开始并且有触摸结束的时候判断屏幕上手指数量 < 2
    square.addEventListener("touchend", function (event: any) {
      if (self.isGestureStart && event.touches.length < 2) {
        let status = self.status;
        if (self.scale > 1) {
          //放大
          // console.log("放大结束", self.scale);
          //多点触控时两手指越来越远
          if (status < 4) {
            self.status = status + 1;
            // console.log("放大后", self.status);
          } else {
            // console.log("已经最大了");
          }
        } else {
          //缩小
          // console.log("缩小结束", self.scale);
          if (status > 1) {
            self.status = status - 1;
            // console.log("缩小后", self.status);
          } else {
            // console.log("已经最小了");
          }
        }
        //重置标记
        self.isGestureStart = false;
        self.startDst = 0;
        self.scale = 1;
      }
    });
  },
  methods: {
    /**
     * 计算两个触点的位置
     * @param touch1 第一个触点
     * @param touch2 第二个触点
     */
    getDst(touch1, touch2) {
      //计算两个直角边的长度
      let x = touch2.clientX - touch1.clientX; //水平方向的距离
      var y = touch2.clientY - touch1.clientY; //垂直方向的距离
      //利用勾股定理，计算两个触点的距离（斜边的长度）
      var z = Math.sqrt(x * x + y * y);
      // 返回结果
      return z;
    },
    // 页面指南关闭
    closeOpen() {
      this.openVisible = false;
    },
    // 数据格式化
    getDetail() {
      let self = this;
      self
        .$requestTime(
          // "https://cover-api.test.thecover.cn/wap/getDSDataInfo",
          "https://api.thecover.cn/wap/getDSDataInfo",
          {},
          "get"
        )
        .then((data) => {
          if (data && data.time_data_url) {
            self
              .$requestTime(data.time_data_url, {}, "get")
              .then((data) => {
                data.reverse();
                let newArr1 = data.filter(function (item, index) {
                  return item.timeline_level && item.timeline_level == "1";
                });
                let newArr2 = data.filter(function (item, index) {
                  return (
                    item.timeline_level &&
                    (item.timeline_level == "1" || item.timeline_level == "2")
                  );
                });
                let newArr3 = data.filter(function (item, index) {
                  return item.timeline_level && !(item.timeline_level == "4");
                });
                let newArr4 = data.filter(function (item, index) {
                  return (
                    item.timeline_level && item.timeline_level.indexOf("/") < 0
                  );
                });
                // console.log("newArr1", newArr1);
                // console.log("newArr2", newArr2);
                // console.log("newArr3", newArr3);
                // console.log("newArr4", newArr4);
                let year1 = self.yearFormat(newArr1, 20);
                let year2 = self.yearFormat(newArr2, 10);
                let year3 = self.yearFormat(newArr3, 5);
                let year4 = self.yearFormat(newArr4, 1);
                self.yearList1 = year1;
                self.yearList2 = year2;
                self.yearList3 = year3;
                self.yearList4 = year4;
                self.yearArr = year1;
                self.getLength(this.yearArr);
                // console.log("year1", year1);
                // console.log("year2", year2);
                // console.log("year3", year3);
                // console.log("year4", year4);
                self.$common.pageLoaded();
                this.$common.track("load", "进入党史时间轴页面"); //埋点
              })
              .catch((res: any) => {});
          }
        })
        .catch((res: any) => {});
    },
    yearFormat(yearArr: Array<any>, status: number) {
      let yearLength = yearArr.length;
      let yearList = {};
      for (let i = 2021; i > 1921; i -= status) {
        let smallYear = i - status;
        let key = i + "-" + smallYear;
        yearList[key] = [];

        for (let j = 0; j < yearLength; j++) {
          let year = parseInt(yearArr[j].year);

          if (year == i && i == 2021) {
            yearList[key].push(yearArr[j]);
          } else if ((year < i && year > smallYear) || year == smallYear) {
            yearList[key].push(yearArr[j]);
          } else if (year == smallYear && smallYear == 1921) {
            yearList[key].push(yearArr[j]);
          }
        }
      }
      return yearList;
    },
    // 右侧打开功能（暂停使用）
    rightLeftTurn(index: number) {
      let last = this.uprightsNow;
      if (this.uprightsNow == index) {
        this.uprightsNow = -1;
        this.uprightsClose = index;
      } else {
        this.uprightsNow = index;
        this.uprightsClose = last;
      }
    },
    // 跳转百科及弹框开启关闭
    goWike() {
      // console.log("跳转到百科" + this.historyId);
      this.$common.track("click", `党史时间轴查看详情跳转百科`); //埋点
      window.location.href =
        // "https://cover-m.test.thecover.cn/history.html?id=" +
        "https://m.thecover.cn/history.html?id=" +
        this.historyId +
        "&source=dstimeline";
      // this.closeHistory();
    },
    openHistory(name: string, brief: string, id: string) {
      this.$common.track("click", `党史时间轴"${name}"事件被点击`); //埋点
      this.historyTitle = name;
      this.historyContent = brief;
      this.historyId = id;
      this.historyVisible = true;
    },
    closeHistory() {
      this.historyTitle = "";
      this.historyContent = "";
      this.historyId = "";
      this.historyVisible = false;
    },
    // 年份展示
    getLength(obj: object) {
      let num = 0;
      for (var item in obj) {
        num++;
      }
      this.yearListLength = num;
    },
    capitalizeStart: function (value) {
      return value.substring(0, 4);
    },
    capitalizeEnd: function (value) {
      return value.substring(5);
    },
    // 滚动监听
    scrollEvent(e) {
      let self = this;
      let arr = document.getElementsByClassName("yearStart") as any;
      let html = document.getElementsByTagName("html")[0] as any;
      let htmlFontS = parseFloat(html.style.fontSize);
      let height = self.$refs.timeLineBox.offsetHeight - htmlFontS * 3.3;
      let yearheight = htmlFontS * 0.3;
      // console.log(height,yearheight)
      let boxScrollTop = self.$refs.scrollDiv.scrollTop;
      // console.log('滚动条高度',boxScrollTop)
      let overYear = [] as any;
      for (let i = 0; i < arr.length; i++) {
        let year = arr[i].getElementsByClassName("content")[0].innerHTML;
        // console.log("年", year);
        if (arr[i].offsetTop <= boxScrollTop + height - yearheight) {
          // console.log(
          //   "年份，div距离，滚动高度",
          //   year,
          //   arr[i].offsetTop,
          //   boxScrollTop + height - yearheight
          // );
          overYear.push(year);
        }
      }
      let nowYear = overYear[overYear.length - 1];
      self.lightArr.map((item, index) => {
        if (
          (nowYear < item.start && nowYear > item.end) ||
          nowYear == item.end ||
          (nowYear == item.start && nowYear == 2021)
        ) {
          self.lightNum = index;
        }
      });
    },
    // 显示或隐藏海报、右侧按钮点击放到到最大颗粒且滑动到最小年
    clickRight(num) {
      let self = this;
      if (num == 4) {
        //海报
        if (!this.showPosterBox) {
          self.drawPoster();
          self.$common.track("click", `点击时间轴分享海报`); //埋点
        } else {
          self.showPosterBox = false;
        }
      } else {
        let lightNum = self.lightNum; //一进来可能是-1
        let smallYear = self.uprights[num].smallYear;
        // this.clickScroll = true;
        // if (lightNum != num) {
        //   //点击不是高亮的块
        //   this.lightNum = num;
        // }
        // console.log("高亮块，最小年", self.lightNum, smallYear);
        //点击跳转最大颗粒
        if (self.status < 4) {
          //不是最大颗粒度,放大到最大颗粒度,并跳转到该阶段最小年
          self.status = 4;
        } else {
          //是最大颗粒度,跳转到该阶段最小年
        }
        self.$nextTick(function () {
          let arr = document.getElementsByClassName("year") as any;
          for (let i = 0; i < arr.length; i++) {
            let year = arr[i].getElementsByClassName("content")[0].innerHTML;
            // console.log("每一年", year);
            if (year == smallYear) {
              // console.log("找到对应的年 年高度", year, arr[i].offsetTop);
              let html = document.getElementsByTagName("html")[0] as any;
              let htmlFontS = parseFloat(html.style.fontSize);
              let height = self.$refs.timeLineBox.offsetHeight - htmlFontS * 3.3;
              let yearheight = htmlFontS * 0.53;
              self.$refs.scrollDiv.scrollTop = arr[i].offsetTop - height + yearheight;
            }
          }
        });
      }
    },
    /*以下为生成分享图*/
    drawPoster() {
      let canvas = document.createElement("canvas");
      canvas.width = 1005;
      canvas.height = 1608;
      let ctx: any = canvas.getContext("2d");
      var posterImgs: any = [];
      posterImgs.push(
        this.defPreImage(require("../assets/img/map-poster.png"))
      );
      posterImgs.push(this.defPreImage(require("../assets/img/qrcode.png")));
      var that = this;
      Promise.all(posterImgs).then((imgs: any) => {
        ctx.drawImage(
          imgs[0],
          0,
          0,
          imgs[0].width,
          imgs[0].height,
          0,
          0,
          imgs[0].width,
          imgs[0].height
        );
        ctx.drawImage(
          imgs[1],
          0,
          0,
          imgs[1].width,
          imgs[1].height,
          1005 - imgs[1].width - 40,
          1588 - imgs[1].height,
          imgs[1].width,
          imgs[1].height
        );

        //绘制字体
        ctx.font = 'bold 60px "Helvetica"';
        ctx.fillStyle = "white";
        // 设置水平对齐方式
        ctx.textAlign = "left";
        // 设置垂直对齐方式
        ctx.textBaseline = "middle";
        ctx.fillText("我是党史百年时间轴", 50, 980);
        ctx.fillText("第", 50, 1125);
        ctx.fillText("期待您的加入，共觅岁月峥嵘！", 50, 1250);

        //绘制字体
        ctx.font = 'bold 120px "Helvetica"';
        ctx.fillStyle = "white";
        // 设置水平对齐方式
        ctx.textAlign = "left";
        // 设置垂直对齐方式
        ctx.textBaseline = "middle";
        // 设置为粗体
        var beginTime = 1619316000;//2021-04-25 10:00:00
        console.log(Math.round(Date.now() / 1000) - beginTime)
        var textNum =
          30000000 +
          Math.round((Math.round(Date.now() / 1000) - beginTime) * 0.183);
        ctx.fillText(textNum, 150, 1110);

        var numberWidth = ctx.measureText(textNum).width;
        //绘制字体
        ctx.font = 'bold 60px "Helvetica"';
        ctx.fillStyle = "white";
        // 设置水平对齐方式
        ctx.textAlign = "left";
        // 设置垂直对齐方式
        ctx.textBaseline = "middle";
        ctx.fillText("位探秘者", 180 + numberWidth, 1125);

        this.posterImg = canvas.toDataURL("image/jpeg");
        this.showPosterBox = true;
      });
    },
    //加载图片
    defPreImage(imgPath) {
      return new Promise((resolve, reject) => {
        let img = new Image();
        img.onload = function () {
          resolve(img);
        };
        img.crossOrigin = "Anonymous";
        img.src = imgPath;
      });
    },
    // 点击海报分享图片
    posterImgClick(e) {
      // console.log("点击图片");
      const _this = this;
      COVERAPP.Method.shareImage({
        image: e.target.src.split(";base64,")[1],
        title: _this.shareData.title,
        desc: _this.shareData.desc,
        imgUrl: _this.shareData.imgUrl,
        link: _this.shareData.link,
        callback(ret: any) {
          // const data = typeof ret == 'string'.toLowerCase() ? JSON.parse(ret) : ret
          // const origin = data.origin || ''
          // if (origin != 'None' && !_this.$common.isEmpty(origin)) {
          //     _this.$common.track('share', '分享图片到' + origin)
          // } else {
          //     _this.$common.track('share', '分享图片');
          // }
        },
      });
    },
    // 放大缩小
    turnScale(type) {
      let status = this.status;
      if (type == "big") {
        //放大
        this.status = status + 1;
        // console.log("放大后", this.status);
      } else {
        //缩小
        this.status = status - 1;
        // console.log("缩小后", this.status);
      }
    },
    // 进入页面
    accessPage(){
       this.access = false;
    }
  },
})
export default class Home extends Vue {}
</script>

<style lang="scss">
// .hom-wrapper-box{
//   height: 100%;
//   width: 100%;
//   overflow: hidden;
  
// }
.home-wrapper {
  position: relative;
  height: 100%;
  width: 100%;
  // max-width: 750px;
  // margin: 0 auto;
  overflow: hidden;
  background: url(../assets/img/backgound.png) top left no-repeat;
  background-size: cover;
}
// 背景
.cloud,
.cloud1,
.bird,
.icon-top-img,
.icon-top-img1,
.text-bottom,
.time-line-box-bg {
  position: absolute;
}
.cloud,
.cloud1 {
  width: 84%;
}
.cloud {
  top: 10%;
  left: -30%;
  animation: cloudMove 15s infinite;
  -webkit-animation: cloudMove 15s infinite;
  animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.bird {
  width: 83%;
  top: 50%;
  right: -50%;
  animation: birdMove 15s infinite;
  -webkit-animation: birdMove 15s infinite;
  animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.cloud1 {
  top: 55%;
  right: -50%;
  animation: cloud1Move 15s infinite;
  -webkit-animation: cloud1Move 15s infinite;
  animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.icon-top-img {
  top: 0.43rem;
  left: 0.32rem;
  width: 1.6rem;
}
.icon-top-img1 {
  top: 0.43rem;
  left: 50%;
  width: 1.3rem;
  transform: translateX(-50%);
}
.text-bottom {
  bottom: 0.13rem;
  right: 0.5rem;
  font-size: 0.27rem;
  color: #7e5439;
  font-weight: 500;
  // text-shadow: 1px 1px 0px #353535;
}
.time-line-box-bg {
  width: 3.6rem;
  height: 100%;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
}
@keyframes cloudMove {
  0% {
    left: -30%;
  }
  66% {
    left: 50%;
  }
  100% {
    left: 50%;
  }
}
@keyframes birdMove {
  0% {
    top: 50%;
    right: -50%;
  }
  66% {
    top: 30%;
    right: 40%;
  }
  100% {
    top: 30%;
    right: 40%;
  }
}
@keyframes cloud1Move {
  0% {
    right: -50%;
  }
  66% {
    right: 40%;
  }
  100% {
    right: 40%;
  }
}
// 内容
// 内容顶部
.time-line-box {
  width: 100%;
  height: 100%;
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 1.8rem 0 1.5rem;
  box-sizing: border-box;
  // background: url("../assets/img/bg.png") no-repeat;
  // background-size: 3.6rem 100%;
  // background-position: 50%;
  min-height: 100%;
}
.time-line-box .top {
  position: relative;
  width: 3.6rem;
  height: 2rem;
  text-align: center;
  flex: 0;
  box-shadow: 0px 10px 5px #b62e2d inset;
}
.time-line-box .top .content {
  width: 3.6rem;
  height: 2rem;
}
.time-line-box .top .top-img {
  position: absolute;
  width: 1.31rem;
  top: 0.43rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}
.time-line-box .top .top-bg {
  position: absolute;
  width: 3.6rem;
  top: 0;
  left: 0;
  z-index: 0;
}
// 内容中部
.time-line-box .center-box {
  position: relative;
  flex: 1;
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;
}
.time-line-box .center {
  margin: 0 auto;
  // width: 7.39rem;
  // background-image: linear-gradient(
  //   180deg,
  //   rgba(182, 46, 45, 1) 0%,
  //   rgba(182, 46, 45, 0) 100%
  // );
  // background-size: 3.6rem 100%;
  // background-position: 50%;
  // background-repeat: no-repeat;
  min-height: 100%;
}
// 每个阶段
.time-line-box .center .center-item {
  // height: 15vh;
  width: 7.39rem;
  // width: 100%;
  font-size: 0.32rem;
  margin: 0 auto;
}
.time-line-box .center .center-item .year {
  position: relative;
  text-align: center;
  font-size: 0.37rem;
  font-weight: bold;
  color: #ffeac3;
  height: 0.53rem;
  line-height: 0.53rem;
  text-shadow: 1px 1px 0px #353535;
}
.time-line-box .center .center-item .year .content {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
}
.time-line-box .center .center-item .year-content {
  position: relative;
  height: 1.32rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 0;
}
.time-line-box .center .center-item .year-content:nth-of-type(odd) {
  flex-direction: row;
  padding-left: 50%;
}
.time-line-box .center .center-item .year-content:nth-of-type(even) {
  flex-direction: row-reverse;
  padding-right: 50%;
}
.time-line-box .center .center-item .year-content.status1 {
  margin-top: -0.2rem;
}
.time-line-box .center .center-item .year-content.status2 {
  margin-top: -0.3rem;
}
.time-line-box .center .center-item .year-content.status3 {
  margin-top: -0.4rem;
}
.time-line-box .center .center-item .year-content.status4 {
  margin-top: -0.5rem;
}
.time-line-box .center .center-item .year-content:nth-of-type(2) {
  margin-top: 0;
}
.time-line-box .center .center-item .year-content .vertical-line {
  position: absolute;
  left: 50%;
  width: 3px;
  background: #ffdc9d;
  z-index: 0;
  transform: translateX(-50%);
}
.time-line-box .center .center-item .year-content .vertical-line.status1 {
  height: 1.12rem;
}
.time-line-box .center .center-item .year-content .vertical-line.status2 {
  height: 1.02rem;
}
.time-line-box .center .center-item .year-content .vertical-line.status3 {
  height: 0.92rem;
}
.time-line-box .center .center-item .year-content .vertical-line.status4 {
  height: 0.82rem;
}
.time-line-box .center .center-item .year-content .icon {
  position: absolute;
  z-index: 1;
  width: 0.24rem;
  left: 50%;
  transform: translateX(-50%);
}
.time-line-box .center .center-item .year-content .line {
  width: 0.93rem;
  height: 1px;
  background: rgba(255, 243, 222, 0.37);
}
.time-line-box .center .center-item .year-content .name-box {
  width: 2.67rem;
  padding: 0 0.21rem;
  height: 1.32rem;
  box-sizing: border-box;
  background: rgba(9, 16, 29, 0.71);
  border-radius: 0.27rem;
  border: 0.03rem solid #ffdc9d;
  cursor: pointer;
}
.time-line-box .center .center-item .year-content .name-box-new {
  width: 2.67rem;
  padding: 0 0.21rem 0.21rem;
  height: 1.49rem;
  box-sizing: border-box;
  background: rgba(9, 16, 29, 0.71);
  border-radius: 0;
  border: none;
  background: url("../assets/img/name-box-new.png") no-repeat top left;
  background-size: cover;
}
.time-line-box .center .center-item .year-content .name-box.active {
  animation: pincEnd 3s 1;
  -webkit-animation: pincEnd 3s 1;
}
.time-line-box .center .center-item .year-content .name-box .empty {
  vertical-align: middle;
  display: inline-block;
  height: 100%;
}
.time-line-box .center .center-item .year-content .name-box .text {
  vertical-align: middle;
  display: inline-block;
}
.time-line-box .center .center-item .year-content .name-box .text span {
  max-height: 0.96rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  font-weight: 500;
  color: #fff2d9;
  font-size: 0.32rem;
  line-height: 0.48rem;
}
// 内容底部

.time-line-box .bottom {
  flex: 0;
  width: 3.6rem;
  height: 2.73rem;
  text-align: center;
}
.time-line-box .bottom .bottom-img {
  width: 100%;
}
// 右侧固定
.right-box{
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  z-index: 2;
  // width: auto;
}
.upright-item {
  position: absolute;
  right: 0;
  height: 18%;
  // width: auto;
  box-sizing: border-box;
  cursor: pointer;
}
.upright-item:nth-of-type(1) {
  top: 5%;
}
.upright-item:nth-of-type(2) {
  top: 24%;
}
.upright-item:nth-of-type(3) {
  top: 43%;
}
.upright-item:nth-of-type(4) {
  top: 62%;
}
.upright-item:nth-of-type(5) {
  top: 81%;
  height: 11%;
}
.upright-item.open {
  animation: fadeInLeft 1s 1;
  -webkit-animation: fadeInLeft 1s 1;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}
.upright-item.close {
  animation: fadeInRight 1s 1;
  -webkit-animation: fadeInRight 1s 1;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}
.upright-item .open {
  width: 20px;
  height: 20px;
  position: absolute;
  left: -10px;
}
.upright-item .open.toClose {
  animation: iconRight 1s 1;
  -webkit-animation: iconRight 1s 1;
  animation-fill-mode: forwards;
  -webkit-animation-fill-mode: forwards;
}
.upright-item .bg {
  width: auto;
  height: 100%;
}
.upright-item .upright-item-stretch {
  width: 8.37rem;
  height: 100%;
  background-color: white;
  padding: 0.21rem 0.32rem;
  box-sizing: border-box;
}
.upright-item .upright-item-stretch .title-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 0.16rem;
}
.upright-item .upright-item-stretch .title-box .left {
  color: #1c232a;
  font-weight: 500;
  font-size: 0.43rem;
}
.upright-item .upright-item-stretch .title-box .right {
  font-size: 0.32rem;
  color: #8f98a2;
}
.upright-item .upright-item-stretch .time {
  font-size: 0.32rem;
  color: #8f98a2;
  padding-bottom: 0.12rem;
}
.upright-item .upright-item-stretch .time::before {
  content: "";
  display: inline-block;
  width: 0.27rem;
  height: 0.27rem;
  background: url("../assets/img/time.png") no-repeat top left;
  background-size: cover;
  margin-right: 0.11rem;
}
.upright-item .upright-item-stretch .content {
  font-size: 0.4rem;
  color: #4b525c;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
@keyframes fadeInLeft {
  0% {
    right: -8.37rem;
  }
  100% {
    right: 0;
  }
}
@keyframes fadeInRight {
  0% {
    right: 0;
  }
  100% {
    right: -8.37rem;
  }
}
@keyframes iconRight {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(180deg);
  }
}
@keyframes pincEnd {
  0% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
/* 弹窗 党史百科 */
.history-flag,
.open-flag {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  height: 100%;
  width: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: baseline;
  align-items: baseline;
}
.open-flag {
  background: rgba(0, 0, 0, 0.8);
}
.open-flag .open-box {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 4.35rem;
  transform: translateY(-50%) translateX(-50%);
  text-align: center;
}
.open-flag .open-box .open1 {
  width: 4.35rem;
}
.open-flag .open-box .open2 {
  width: 2.83rem;
  padding-top: 1.2rem;
  cursor: pointer;
}
.history-flag .flag-content {
  background: #fff;
  border-radius: 0.241546rem;
  text-align: center;
  font-size: 0.4rem;
  padding: 0.64rem;
  width: 78%;
  box-sizing: border-box;
  position: fixed;
  top: 20%;
  left: 50%;
  transform: translateX(-50%);
  max-width: 585px;
}

.history-flag .history-close {
  position: absolute;
  width: 0.32rem;
  height: 0.32rem;
  top: 0.32rem;
  right: 0.32rem;
  cursor: pointer;
}
.history-flag .history-close.hidden {
  display: none;
}

.history-flag .flag-center {
  word-break: break-all;
  font-size: 0;
}
.history-flag .history-head {
  display: flex;
  justify-content: center;
  align-items: center;
}
.history-flag .flag-head-img1 {
  width: 1.07rem;
}
.history-flag .flag-head-line {
  display: inline-block;
  width: 0.03rem;
  height: 0.61rem;
  margin: 0 0.24rem 0 0.27rem;
  background: #ffd8d8;
}
.history-flag .flag-head-img2 {
  width: 2.13rem;
  margin-top: -0.1rem;
}
.history-flag .history-title {
  font-size: 0.64rem;
  font-weight: 500;
  text-align: left;
  padding: 0.43rem 0 0.21rem;
  word-break: break-all;
  overflow: hidden; // 超出的文本隐藏
  text-overflow: ellipsis; // 溢出用省略号显示
  white-space: nowrap; // 溢出不换行
}

.history-flag .history-content {
  height: 6.4rem;
  line-height: 0.64rem;
  overflow: hidden;
  font-size: 0.4rem;
  text-align: left;
  color: #4b525c;
}
.history-flag .flag-btns{
  color:#FA1B38;
  font-size: 0.5rem;
  background-color: #FFE4E4;
  border-radius: 4rem;
  height: 1.2rem;
  line-height: 1.2rem;
  cursor: pointer;
}
// .history-flag .flag-btns .history-detail {
//   width: 100%;
// }
.history-more-wrap {
  margin-top: -1rem;
  position: relative;
  z-index: 2;
  box-sizing: border-box;
  height: 1rem;
}

.history-more-wrap:before {
  content: "";
  background: -webkit-linear-gradient(
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1)
  );
  background: -o-linear-gradient(
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1)
  );
  background: -moz-linear-gradient(
    rgba(255, 255, 255, 0),
    rgba(255, 255, 255, 1)
  );
  background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 1));
  position: absolute;
  left: 0;
  top: 0;
  height: 1rem;
  width: 100%;
}
.poster-box {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba($color: #000000, $alpha: 0.7);
  z-index: 90;
  .poster-info {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    .poster-img {
      width: 85.28vw;
      display: block;
      margin: 0 auto;
      border-radius: 1.85vw;
      max-width: 400px;
    }
    .save-tips-text {
      font-size: 0.3rem;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 0.44rem;
      text-align: center;
      margin-top: 0.4rem;
    }
  }
}
.operate-box {
  position: fixed;
  bottom: 0.14rem;
  left: 0;
}
.operate-box img {
  width: 0.91rem;
  height: 0.91rem;
  padding-left: 0.32rem;
  cursor: pointer;
}
.access-images-box{
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  background: url('../assets/img/bg1.jpg') no-repeat left top;
  background-size: 100% 100%;
}
.access-images-content{
  position: relative;
  width: 100vw;
  height: 100vh;
  max-width: 750px;
  margin: 0 auto;
  background: url('../assets/img/bg3.png') no-repeat left top;
  background-size: 100% 100%;
}
.access-images-content img{
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: auto;
}
.access-images-content .one{
  height: 4%;
  top: 2.5%;
}
.access-images-content .two{
  height: 42%;
  top: 3.5%;
}
.access-images-content .three{
  height: 18%;
  top: 14%;
}
.access-images-content .four{
  height: 30%;
  top: 55%;
}
.access-images-content .five{
  height: 20%;
  top: 75%;
  cursor: pointer;
}
</style>
